/** */
import {
  ADD_ONE_NEURON_TO_STORE,
  ADD_MANY_NEURONS_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  REMOVE_MANY_NEURONS_FROM_STORE,
  REMOVE_ONE_NEURON_FROM_STORE,
  LOAD_NEURONS_TO_STORE,
  UPDATE_NEURON
} from '../actions/neuron';

export default (state = {}, action) => {
  const { type, payload } = action;
  const current_state = state;
  switch (type) {
    case ADD_MANY_NEURONS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (neurons, neuron) => ({
            ...neurons,
            [neuron.id]: neuron
          }),
          {}
        )
      };
    case ADD_ONE_NEURON_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (neurons, neuron) => ({
            ...neurons,
            [neuron.id]: neuron
          }),
          {}
        )
      };
    case LOAD_NEURONS_TO_STORE:
      return {
        ...payload.reduce(
          (neurons, neuron) => ({
            ...neurons,
            [neuron.id]: neuron
          }),
          {}
        )
      };
    case REMOVE_MANY_NEURONS_FROM_STORE:
      payload.forEach((id) => delete current_state[id]);
      return {
        ...current_state
      };
    case REMOVE_ONE_NEURON_FROM_STORE:
      delete current_state[payload];
      return { ...current_state };
    case UPDATE_NEURON:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          ...payload
        }
      };
    default:
      return state;
  }
};
